/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    HTTPVersion,
    IHTTPVersionMatch,
    MatchOperation,
} from 'generated-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * @description  HTTPVersionMatch ConfigItem class.
 * @author Abhinesh Gour
 */
export class HTTPVersionMatchConfigItem extends MessageItem<IHTTPVersionMatch> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'HTTPVersionMatch',
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Set match_criteria if it is not set already.
     * @override
     */
    public modifyConfigDataAfterLoad(): void {
        const { match_criteria: matchCriteria } = this.config;

        super.modifyConfigDataAfterLoad();

        if (!matchCriteria) {
            this.config.match_criteria = MatchOperation.IS_IN;
        }
    }

    /**
     * Getter for selected http versions.
     */
    public get versions(): HTTPVersion[] {
        return this.config.versions;
    }

    /** @override */
    public modifyConfigDataBeforeSave(): void {
        const { match_criteria: matchCriteria } = this.config;

        super.modifyConfigDataBeforeSave();

        if (!matchCriteria) {
            this.config.match_criteria = MatchOperation.IS_IN;
        }
    }
}
